import _ from 'lodash'

export function serializeProblemSolving(data) {
  const {
    categories = [],
    location = {},
    name,
    problemAnalysis = {},
    reviewPhase = {},
    rootCauses = [],
    team = {},
    status,
    priority,
    dueDate,
    problemBreakdown,
    processGaps = [],
    processMapMedia = [],
    solutionMedia = [],
    solutionDescription,
    lang,
    notes,
    canceledReason,
    onHoldReason,
    impactStartsAt,
    impactEndsAt,
  } = data

  return {
    problemBreakdown,
    categories,
    location: serializeLocation(location),
    name,
    notes,
    problemAnalysis: serializeProblemAnalysis(problemAnalysis),
    processGaps,
    processMapMedia: processMapMedia.map(media => media?.id),
    reviewPhase: serializeReviewPhase(reviewPhase),
    rootCauses: rootCauses.map(serializeRootCause),
    team: serializeTeam(team),
    status,
    priority,
    dueDate,
    solutionMedia: solutionMedia.map(media => media?.id),
    solutionDescription,
    lang,
    canceledReason,
    onHoldReason,
    impactStartsAt,
    impactEndsAt,
  }
}

function serializeLocation(location = {}) {
  const tags = _.get(location, 'tags') || []

  return {
    site: _.get(location, 'site._id') || _.get(location, 'site'),
    tags: tags.map(t => t._id || t),
  }
}

function serializeProblemAnalysis(problemAnalysis = {}) {
  const problemMedia = problemAnalysis?.problemMedia ?? []
  const countermeasuresMedia = problemAnalysis?.countermeasuresMedia ?? []
  const rootCauseMedia = problemAnalysis?.rootCauseMedia ?? []
  const measureAttachments = problemAnalysis?.measureAttachments ?? []
  const measureMedia = problemAnalysis?.measureMedia ?? []

  return {
    businessRequirements: problemAnalysis?.businessRequirements ?? '',
    containment: problemAnalysis?.containment ?? '',
    countermeasuresMedia: countermeasuresMedia.map(m => m.id),
    goals: problemAnalysis?.goals ?? '',
    measureAttachments,
    measureDescription: problemAnalysis?.measureDescription ?? '',
    measureMedia: measureMedia.map(m => m.id),
    problem: problemAnalysis?.problem ?? '',
    problemMedia: problemMedia.map(m => m.id),
    rootCauseMedia: rootCauseMedia.map(m => m.id),
  }
}

function serializeTeam(team) {
  const collaborators = _.get(team, 'collaborators') || []
  const serializedTeam = {
    owner: _.get(team, 'owner._id', ''),
    coach: _.get(team, 'coach._id', ''),
    collaborators: collaborators.map(c => c._id),
  }

  return _.omitBy(serializedTeam, _.isEmpty)
}

function serializeRootCause(rootCause, index) {
  const id = rootCause?.id
  const correctiveActionMedia = rootCause?.correctiveActionMedia ?? []
  const correctiveActionAssignees = rootCause?.correctiveActionAssignees ?? []

  const serializedRootCause = {
    name: rootCause?.name ?? '',
    type: rootCause?.type ?? null,
    description: rootCause?.description ?? '',
    correctiveAction: rootCause?.correctiveAction ?? '',
    correctiveActionWorked: rootCause?.correctiveActionWorked,
    correctiveLearning: rootCause?.correctiveLearning,
    correctiveActionMedia: correctiveActionMedia.map(m => m.id),
    correctiveActionAssignees: correctiveActionAssignees.map(
      assignee => assignee.id
    ),
    preventiveAction: rootCause?.preventiveAction ?? '',
    position: index,
    analysisWhyBreakdown: rootCause?.analysisWhyBreakdown ?? [],
  }

  if (id) serializedRootCause.id = id

  return serializedRootCause
}

function serializeReviewPhase(reviewPhase = {}) {
  const {
    estimationExplanation = '',
    impacts = [],
    investments = [],
  } = reviewPhase
  const costReduction = reviewPhase?.costReduction?.capturedValue ?? null
  const investment = reviewPhase?.investment?.capturedValue ?? null
  const revenue = reviewPhase?.revenue?.capturedValue ?? null

  const timeTracking = reviewPhase?.timeTracking ?? {
    timeReductionByMonth: null,
    timeInvested: null,
  }

  const serializedReview = {
    estimationExplanation,
    timeTracking,
    impacts,
    investments,
  }

  if (costReduction !== null) {
    _.set(
      serializedReview,
      'costReduction.capturedValue',
      String(costReduction)
    )
  }

  if (investment !== null) {
    _.set(serializedReview, 'investment.capturedValue', String(investment))
  }

  if (revenue !== null) {
    _.set(serializedReview, 'revenue.capturedValue', String(revenue))
  }
  return serializedReview
}
